import {
  Component,
  Input,
  ViewContainerRef,
  ViewChild,
  OnInit,
} from "@angular/core";
import { ZoneComponent } from "./zone-component";
import { ZoneError } from "@/shared-module/models";

@Component({
  selector: "app-zone-error",
  templateUrl: "zone-error.component.html",
})
export class ZoneErrorComponent implements OnInit, ZoneComponent {
  @Input() data: ZoneError;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;
  @ViewChild("template", { static: true }) template;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }
}
